import { apiRequest } from '../../../../shared/api/index.js';
import type { OperationLinkInput } from '../../model/operation-link.js';
import type { OperationLinkBodyDto } from '../dto/operation-link-body.dto.js';
import { toOperationLinkBody } from '../mappers/operation-link-body.mapper.js';

const postOperationLink = async (
  operationId: string,
  body: OperationLinkBodyDto,
): Promise<void> => {
  await apiRequest<void>(`/bank/transactions/${operationId}/link`, { method: 'POST', body });
};

export const linkOperation = async (input: OperationLinkInput): Promise<void> => {
  await postOperationLink(input.operationId, toOperationLinkBody(input));
};
